// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"753":"007b0553","8568":"b61a2dff","9724":"58d3d23f"}[chunkId] + ".chunk.css";
};